<div class="modal fade" id="{{modalId}}" tabindex="-1" aria-modal="true" role="dialog">
  <div class="modal-dialog {{modalSize}} modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" *ngIf="displayHeader">
        <h5 class="modal-title">{{modalTitle}}</h5>
        <button type="button" class="btn-close btn-modal-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <!--<table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Url</th>
        <th scope="col">Submitted Urls</th>

      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let sitemap of sitemaps; index as i">
        <th scope="row">{{i+1}}</th>
        <td>{{sitemap.url}}</td>
        <td>{{sitemap.submittedUrls}}</td>
      </tr>

    </tbody>
  </table>-->

        <ng-content></ng-content>
      </div>

    </div>
  </div>
</div><!-- End Modal Dialog Scrollable-->
